import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { ISkillList } from '~types/review';

import QueryKeys from '../queryKeys';

export default function useGetCompanySkillList(companyHash?: string) {
  return useQuery<ISkillList>(
    [QueryKeys.companySkillList, companyHash],
    () => fetcher(`/api/skill/${companyHash}`),
    { enabled: !!companyHash, cacheTime: 0 },
  );
}
